import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getInitialData, loginAndFetchData, refreshAndFetchData, logoutUser } from '../../features/user/userSlice';
import { Button, Col, Form, Input, Row } from 'antd';
import logo from '../../assets/images/logo.png';
import { useContext, useEffect} from 'react';
import { NotificationContext } from '../../providers/NotificationProvider';

type FieldType = {
  username?: string;
  password?: string;
};

const LoginForm: React.FC = () => {

  useEffect(() => {
    const validateToken = async () => {
      const storedAccessToken = localStorage.getItem('refresh');
      if (storedAccessToken) {
        try {
          await dispatch(refreshAndFetchData(storedAccessToken) as any).then((result : any) => {
            if (getInitialData.fulfilled.match(result)) {
              navigate('/dashboard'); // Redirige al usuario a /dashboard si la autenticación es exitosa
            }
          })
          .catch((error : any) => {
            console.error('Login failed:', error);
          });
        } catch (error) {
          dispatch(logoutUser()); 
        }
      } 
    };

    validateToken();
    // eslint-disable-next-line 
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { triggerNotification } = useContext(NotificationContext);

  const handleSubmit = (values : any) => {
  
dispatch(loginAndFetchData({ username: values.username as string, password: values.password as string }) as any)
      .then((result : any) => {
        if (getInitialData.fulfilled.match(result)) {
          navigate('/dashboard'); // Redirige al usuario a /dashboard si la autenticación es exitosa
        }
      })
      .catch((err: any) => {
        triggerNotification('error', 'Error', err.message, 'bottomRight')
      });
  };

  return (
    <div className="home-login">
      <Row >
<Col className='form-login-container'>
      
      <img src={logo} alt="logo" className='logo' />
      <Form
    name="basic"
    style={{ maxWidth: 600 }}
    initialValues={{ remember: true }}
    onFinish={handleSubmit}
    autoComplete="off"
  >
    <Form.Item<FieldType>
      label="Usuario"
      name="username"
      rules={[{ required: true, message: 'Por favor ingresa tu usuario.' }]}
    >
      <Input />
    </Form.Item>

    <Form.Item<FieldType>
      label="Contraseña"
      name="password"
      rules={[{ required: true, message: 'Por favor ingresa tu contraseña.' }]}
    >
      <Input.Password />
    </Form.Item>

    <Form.Item >
      <Button type="primary" htmlType="submit">
        Iniciar Sesión
      </Button>
    </Form.Item>
    <Link to="/recovery-password">Olvidé mi contraseña</Link>
  </Form>

      </Col>
      </Row>
    </div>
    
  );
};

export default LoginForm;
